import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox/lib/dialog';
import {
  hideRemoveModuleItemsConfirmationDialog,
  removeModuleCardItems,
} from 'manage-modules/redux/manageModulesActions';
import theme from 'manage-modules/components/dialog/ModuleItemsRemoveConfirmationDialogTheme.css';

const ModuleItemsRemoveConfirmationDialog = ({
  active,
  itemsSynced,
  onCancel,
  onRemove,
  selectedItemIds,
}) =>
  <Dialog
    theme={theme}
    active={active}
    title="Are you sure?"
    onEscKeyDown={onCancel}
    onOverlayClick={onCancel}
    actions={[
      { label: 'Cancel', onClick: onCancel },
      {
        label: 'Remove',
        onClick: itemsSynced
          ? onRemove
          : () => console.log('Not synced, remove ignored'),
      },
    ]}
  >
    {selectedItemIds.length === 1
      ? <p>Remove the selected item?</p>
      : <p>
          Remove all {selectedItemIds.length} selected items?
        </p>}
  </Dialog>;

const mapStateToProps = state => {
  const {
    itemsSynced,
    removeItemsConfirmationDialog,
    selectedItemIds,
  } = state.manageModules.moduleCard;
  return {
    active: removeItemsConfirmationDialog.active,
    itemsSynced,
    selectedItemIds,
  };
};

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(hideRemoveModuleItemsConfirmationDialog()),
  onRemove: () => dispatch(removeModuleCardItems()),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  ModuleItemsRemoveConfirmationDialog,
);
